import { render } from "./CxMessagePopupActions.vue?vue&type=template&id=45c77e22"
import script from "./CxMessagePopupActions.vue?vue&type=script&lang=js"
export * from "./CxMessagePopupActions.vue?vue&type=script&lang=js"

import "./CxMessagePopupActions.vue?vue&type=style&index=0&id=45c77e22&lang=less"

import exportComponent from "/home/ec2-user/workspace/_conx-ui-monorepo_ui2_lab_master/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__